import { useState } from 'react'
import { useIntl } from '@/intl'

export const useTexts = () => {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    labels: {
      trackDriver: translate({ id: 'form.drivers.edit.fields.trackDriver.label' }),
      gpsDeviceId: translate({ id: 'form.drivers.edit.fields.gpsDeviceId.label' }),
    },
    helpers: {
      trackDriver: translate({ id: 'form.drivers.edit.fields.trackDriver.helper' }),
    },
    tooltips: {
      noAvailableVirtualDevices: translate({
        id: 'form.drivers.edit.fields.trackDriver.tooltip.noAvailableVirtualDevices',
      }),
    },
  }))

  return api
}
